var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"btn-top c-p",class:_vm.scroll_bottom ? 'show-btn' : '',on:{"click":function($event){return _vm.$scrollToTop()}}},[_c('i',{staticClass:"icon-top"}),_c('i',{staticClass:"icon-up"})])
}
var staticRenderFns = []

export { render, staticRenderFns }